import { FunctionalComponent, h } from '@stencil/core';

interface AafpImageLinkProps {
  link: HTMLElement;
  date: string | null;
  description: string;
  image: string;
  [key: string]: any;
  imageSize?: string;
}

export const AafpImageLink: FunctionalComponent<AafpImageLinkProps> = ({
  date,
  description,
  image,
  link,
  imageSize,
}) => (
  <div class="adl-image-link">
    <div class="adl-image-link__content-wrapper">
      {imageSize && imageSize !== '' ? (
        <img class={`adl-image-link__image adl-image-link__image-${imageSize}`} src={image} />
      ) : (
        <img class="adl-image-link__image none" src={image} />
      )}
      <div class="adl-image-link__details">
        <div class="adl-image-link__aafp-link" ref={el => el && el.append(link)}></div>
        <div class="adl-image-link__details-text">
          {date && <span class="adl-body adl-image-link__date">{date}</span>}
          {date && <div class="adl-image-link__separator"></div>}
          <span class="adl-body adl-image-link__description">{description}</span>
        </div>
      </div>
    </div>
  </div>
);
